import React, { Dispatch, SetStateAction, useEffect } from 'react'

import { Modal, useCompanyPrefillData } from '@pepper/ui'
import { CompanyInfo, JOURNEYSTAGE } from './CreateOrganisationJourney'
import loadingGif from 'assets/gif/loading.gif'
import styles from './_.module.css'

type Props = {
  company: CompanyInfo
  companyId: string
  setJourneyState: Dispatch<SetStateAction<JOURNEYSTAGE>>
  setCompanyDetail: Dispatch<SetStateAction<Prefillbiodata>>
}

function FetchOrgDetails({
  company,
  companyId,
  setJourneyState,
  setCompanyDetail,
}: Props): JSX.Element {
  const { data, isLoading, error } = useCompanyPrefillData(
    `companyPrefillData/${companyId}/${company.organisationWebsite}`,
    companyId
  )

  useEffect(() => {
    if (error) {
      setJourneyState(JOURNEYSTAGE.CLOSED)
    }
  }, [error, setJourneyState])

  useEffect(() => {
    if (!data) return
    setCompanyDetail(data)
    setJourneyState(JOURNEYSTAGE.EDIT_ORG_DETAILS)
  }, [data, setCompanyDetail, setJourneyState, company])

  return (
    <Modal visible={isLoading} footer={null} className={styles.modal}>
      <div className={styles.wrapper}>
        <img src={loadingGif} alt="loading" />
        <h2>Hold on a sec!</h2>
        We are making your life easier by pre-filling some information
      </div>
    </Modal>
  )
}

export default FetchOrgDetails
